import { render, staticRenderFns } from "./RegularScheduleIcon.vue?vue&type=template&id=34a0dc3a&scoped=true&"
import script from "./RegularScheduleIcon.vue?vue&type=script&lang=js&"
export * from "./RegularScheduleIcon.vue?vue&type=script&lang=js&"
import style0 from "./RegularScheduleIcon.vue?vue&type=style&index=0&id=34a0dc3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a0dc3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VHover,VIcon,VRow})
